import React from 'react';

import Phrase from '../Reader/Phrase';
import {ToolTipContainer} from './CorrectionManager';
import { getUserData } from '../../services/API';
import { withRouter } from 'react-router-dom';
import DialogIndicator from '../Global/DialogIndicator/DialogIndicator';
import { withTranslation } from 'react-i18next';

class RunningRecord extends React.Component {
  constructor (props){
    super(props);
    this.state = {
      totalSkips: 0,
      totalMispronunciations: 0,
      totalSelfCorrections: 0,
      totalErrors: 0,
    };

    this.calculateTotals = this.calculateTotals.bind(this);
    this.isDisabled = this.isDisabled.bind(this);
    this.canGrayOut = this.canGrayOut.bind(this);
    this.enableExtendedColumns = getUserData().sorConfig.enableExtendedColumns;
  }

  componentDidMount(){
    this.calculateTotals();
  }

  calculateNumErrors(errors){
    return errors.reduce(((totalErrors, currentError) => currentError ? totalErrors + 1 : totalErrors), 0);
  }

  calculateTotals(){
    let totalErrors = 0;
    this.props.scoredStory.phrases.forEach((phrase, index) => {
      let numErrors = this.calculateNumErrors(this.props.errors[index]);
      totalErrors += numErrors;
    });
    if(this.isDisabled()) totalErrors = "";
    let totalSelfCorrections = this.props.stats.selfCorrections.reduce(((total, value) => value ? total + value : total), 0);
    let totalSkips = this.props.stats.skips.reduce(((total, value) => value ? total + value : total), 0);
    let totalMispronunciations = this.props.stats.mispronunciations.reduce(((total, value) => value ? total + value : total), 0);
    this.setState({
      totalSelfCorrections: totalSelfCorrections,
      totalSkips,
      totalMispronunciations,
      totalErrors: totalErrors,
    });
  }

  setSelfCorrections(newValue, phraseIndex){
    let selfCorrections = this.props.stats.selfCorrections;
    selfCorrections[phraseIndex] = newValue;
    let newStats = this.props.stats;
    newStats.selfCorrections = selfCorrections;
    this.props.setStats(newStats, this.calculateTotals);
  }

  setSkips(newValue, phraseIndex){
    let skips = this.props.stats.skips;
    skips[phraseIndex] = newValue;
    let newStats = this.props.stats;
    newStats.skips = skips;
    this.props.setStats(newStats, this.calculateTotals);
  }

  setMispronunciations(newValue, phraseIndex){
    let mispronunciations = this.props.stats.mispronunciations;
    mispronunciations[phraseIndex] = newValue;
    let newStats = this.props.stats;
    newStats.mispronunciations = mispronunciations;
    this.props.setStats(newStats, this.calculateTotals);
  }

  isDisabled(){
    const statusId = this.props.scoredStory.sidebarStatus.id
    return ["PRE-READER", "UNDER_REVIEW"].includes(statusId)
  }

  canGrayOut(phraseIndex, wordIndex){
    const isEndingPhrase = phraseIndex === this.props.scoredStory.phrases.length - 1;
    // great than or equal to because errors array can be shorter than the phrase when the word is not spoken.
    const isEndingWord = wordIndex >= this.props.errors[phraseIndex].length - 1; 
    
    // ending phrase and ending word
    if(isEndingPhrase && isEndingWord) return true;

    // ending phrase, but not ending word
    if(isEndingPhrase && !isEndingWord) return false;

    if(isEndingWord){ // ending word in a non-ending phrase
      // check all subsequent phrases for errors, if there are none, then gray out.
      for(let i = phraseIndex + 1; i < this.props.scoredStory.phrases.length; i++){
        if(this.props.errors[i].length > 0){
          return false;
        }
      }
      return true;
    }

    // not ending phrase, not ending word
    // (great than or equal to because errors array can be shorter than the phrase when the word is not spoken.)
    return wordIndex >= this.props.errors[phraseIndex].length-1 ; 
  }

  getPhraseRows(){
    return this.props.scoredStory.phrases.map((phrase, index) => {
      let phraseErrors = this.props.errors[index];
      let rowValidationClass = this.props.phraseCorrectionErrors[index] ? "error-row" : "";
      let inputClassName = this.isDisabled() ? "statInput noCursor" : "statInput"
      let numErrors = this.isDisabled() ? "" : this.calculateNumErrors(phraseErrors);
      let isPhraseDisabled = this.isDisabled();
      let isPhraseWordStylingEnabled = !isPhraseDisabled;
      if (!isPhraseDisabled && !this.props.allowRescoring) {
        isPhraseDisabled = true;
        isPhraseWordStylingEnabled = true;
      }
        return(
          <tr key={"row" + index} className="phraseRow">
            <td className="cell">
              {index + 1}
              {this.props.scoredStory.comprehensionDialog && 
                this.props.scoredStory.comprehensionDialog.filter(dialog => dialog.phraseIndex === index).length > 0 && (
                  <a onClick={() => this.props.history.push({
                    pathname: `/teacher/gradebook/comprehension`,
                    search: `?activityId=${this.props.activityId}&phraseIndex=${index}`,
                    state: { student: this.props.scoredStory.student }
                  })}>
                    <DialogIndicator tooltip="Phrase has comprehension dialog." />
                  </a>
                )
              }
            </td>
            <td className="cell text">
              <Phrase
                canGrayOut={this.canGrayOut}
                text={phrase.text}
                final={true}
                storyErrors={this.props.errors}
                errors={phraseErrors}
                phrases={this.props.scoredStory.phrases}
                phraseIndex={index}
                key={"phrase" + index}
                isCorrection={true}
                setErrors={(errors, newFlags, phraseIndex)=>{
                  let indexForInsert = phraseIndex || index;
                  this.props.setErrors(errors, indexForInsert, this.calculateTotals)
                }}
                config={{}}
                isDisabled={isPhraseDisabled}
                phraseWordStylingEnabled={isPhraseWordStylingEnabled}
                flaggedWords={this.props.flaggedWords[index]}
              />
            </td>
            <ToolTipContainer placement="bottom" type="phrase_correction_error" disabled={!this.props.phraseCorrectionErrors[index]}>
              <td className={`cell number ${rowValidationClass}`}>{numErrors}</td>
            </ToolTipContainer>
            {this.enableExtendedColumns && 
              <>
                <td className="cell number">
                  <input type='number' className={inputClassName}
                    disabled={isPhraseDisabled}
                    onChange={(event) => this.setSelfCorrections(parseInt(event.target.value), index)}
                    defaultValue={this.props.stats.selfCorrections[index] || ""}
                  />
                </td>
                <ToolTipContainer placement="bottom" type="phrase_correction_error" disabled={!this.props.phraseCorrectionErrors[index]}>
                  <td className={`cell number ${rowValidationClass}`}>
                    <input type='number' className={inputClassName}
                      disabled={isPhraseDisabled}
                      onChange={(event) => this.setSkips(parseInt(event.target.value), index)}
                      defaultValue={this.props.stats.skips[index] || ""}
                    />
                  </td>
                </ToolTipContainer>
                <ToolTipContainer placement="bottom" type="phrase_correction_error" disabled={!this.props.phraseCorrectionErrors[index]}>
                  <td className={`cell number ${rowValidationClass}`}>
                    <input type='number' className={inputClassName}
                      disabled={isPhraseDisabled}
                      onChange={(event) => this.setMispronunciations(parseInt(event.target.value), index)}
                      defaultValue={this.props.stats.mispronunciations[index] || ""}
                    />
                  </td>
                </ToolTipContainer>
              </>
            }
          </tr>
        );
    });
  }

  render() {
    const {t} = this.props;
    return (
      <div className="runningRecord">
        <table className="table">
          <thead>
            <tr className="tableHeader">
              <th className="label"></th>
              <th />
              <ToolTipContainer placement="bottom" type="error"><th className="label">{t("Errors")}</th></ToolTipContainer>
              {this.enableExtendedColumns && 
                <>
                  <ToolTipContainer placement="bottom" type="self-corrections"><th className="label">{t("Self Corrections")}</th></ToolTipContainer>
                  <ToolTipContainer placement="bottom" type="skips"><th className="label">{t("Skips")}</th></ToolTipContainer>
                  <ToolTipContainer placement="bottom" type="miscues"><th className="label">{t("Mistakes")}</th></ToolTipContainer>
                </>
              }
            </tr>
          </thead>
          <tbody>
          <tr className="totalRow">
              <th></th>
              <th className="totalLabel">{t("Totals")}</th>
              <th className="total">{this.state.totalErrors}</th>
              {this.enableExtendedColumns && 
                <>
                  <th className="total">{this.state.totalSelfCorrections || ""}</th>
                  <th className="total">{this.state.totalSkips || ""}</th>
                  <th className="total">{this.state.totalMispronunciations || ""}</th>
                </>
              }
            </tr>
            {this.getPhraseRows()}
          </tbody>
        </table>
      </div>
    );
  }
}

export default withRouter(withTranslation("review_activity")(RunningRecord))